var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-layout",
    { attrs: { "align-center": "", "justify-center": "", role: "region" } },
    [
      _c(
        "v-flex",
        { attrs: { xs11: "", sm11: "", md11: "", md4: "", lg4: "" } },
        [
          _c(
            "v-card",
            {
              attrs: {
                color: "secondary",
                role: "region",
                "aria-label": "User login form",
              },
            },
            [
              _c(
                "v-app-bar",
                { attrs: { flat: "" } },
                [
                  _c(
                    "v-toolbar-title",
                    {
                      staticClass: "text-body-2",
                      attrs: { role: "heading", "aria-level": "1" },
                    },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.$t("components.login.title")) +
                          "\n        "
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c("v-spacer"),
                  _vm._v(" "),
                  _c(
                    "v-tooltip",
                    {
                      attrs: {
                        bottom: "",
                        role: "tooltip",
                        "aria-hidden": "true",
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "activator",
                          fn: function (ref) {
                            var on = ref.on
                            var attrs = ref.attrs
                            return [
                              _c(
                                "v-btn",
                                _vm._g(
                                  _vm._b(
                                    {
                                      attrs: {
                                        "aria-label": "New player? Sign up",
                                        color: "accent",
                                        dark: "",
                                        to: _vm.toSignUpLink,
                                      },
                                    },
                                    "v-btn",
                                    attrs,
                                    false
                                  ),
                                  on
                                ),
                                [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(
                                        _vm.$t(
                                          "components.login.buttons.singup"
                                        )
                                      ) +
                                      "\n            "
                                  ),
                                ]
                              ),
                            ]
                          },
                        },
                      ]),
                    },
                    [
                      _vm._v(" "),
                      _c("span", [
                        _vm._v(
                          _vm._s(_vm.$t("components.login.buttons.signupPopup"))
                        ),
                      ]),
                    ]
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-container",
                { attrs: { fluid: "", "grid-list-md": "" } },
                [
                  _c("v-progress-linear", {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.isLoading,
                        expression: "isLoading",
                      },
                    ],
                    attrs: {
                      color: "accent",
                      indeterminate: "",
                      role: "status",
                      "aria-label": "Signing in, please wait",
                    },
                  }),
                  _vm._v(" "),
                  _vm._l(
                    _vm.filteredErrors,
                    function (errorsGroup, errorsGroupIndex) {
                      return _c(
                        "div",
                        {
                          key: errorsGroupIndex,
                          attrs: { "aria-live": "polite" },
                        },
                        _vm._l(errorsGroup, function (error) {
                          return _c(
                            "v-alert",
                            {
                              key: error.id,
                              attrs: {
                                type: error.type,
                                icon: error.icon,
                                role: "alert",
                              },
                            },
                            [
                              _vm._v(
                                "\n            " +
                                  _vm._s(error.msg) +
                                  "\n          "
                              ),
                            ]
                          )
                        }),
                        1
                      )
                    }
                  ),
                  _vm._v(" "),
                  _c(
                    "v-layout",
                    {
                      attrs: {
                        "justify-center": "",
                        "align-center": "",
                        "aria-label": "Social sign-in options",
                        role: "group",
                      },
                    },
                    [
                      _c(
                        "v-flex",
                        {
                          attrs: {
                            "text-center": "",
                            flex: "",
                            xs12: "",
                            sm8: "",
                            md9: "",
                          },
                        },
                        [
                          _c(
                            "v-btn",
                            {
                              attrs: {
                                "aria-label": "Sign in with Facebook",
                                icon: "",
                                color: "accent",
                                href: _vm.oAuthLinks.fb,
                              },
                            },
                            [
                              _c("v-icon", { attrs: { small: "" } }, [
                                _vm._v(
                                  "\n                fab fa-facebook-f\n              "
                                ),
                              ]),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-btn",
                            {
                              attrs: {
                                "aria-label": "Sign in with Google",
                                icon: "",
                                color: "accent",
                                href: _vm.oAuthLinks.google,
                              },
                            },
                            [
                              _c("v-icon", { attrs: { small: "" } }, [
                                _vm._v(
                                  "\n                fab fa-google\n              "
                                ),
                              ]),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-btn",
                            {
                              attrs: {
                                "aria-label": "Sign in with GitHub",
                                icon: "",
                                color: "accent",
                                href: _vm.oAuthLinks.github,
                              },
                            },
                            [
                              _c("v-icon", { attrs: { small: "" } }, [
                                _vm._v(
                                  "\n                fab fa-github-alt\n              "
                                ),
                              ]),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-form",
                    {
                      attrs: {
                        role: "form",
                        "aria-labelledby": "loginFormTitle",
                      },
                      on: {
                        submit: function ($event) {
                          $event.preventDefault()
                          return _vm.validate($event)
                        },
                      },
                    },
                    [
                      _c(
                        "v-layout",
                        [
                          _c(
                            "v-flex",
                            { attrs: { xs12: "" } },
                            [
                              _c("v-text-field", {
                                directives: [
                                  {
                                    name: "validate",
                                    rawName: "v-validate",
                                    value: "required|min:6|max:255",
                                    expression: "'required|min:6|max:255'",
                                  },
                                ],
                                attrs: {
                                  "prepend-icon": "fal fa-user",
                                  color: "accent",
                                  autocomplete: "username",
                                  "data-vv-as": "username",
                                  "data-vv-name": "username",
                                  "error-messages":
                                    _vm.errors.collect("username"),
                                  label: "Username",
                                  name: "username",
                                  type: "text",
                                  "aria-required": "true",
                                },
                                model: {
                                  value: _vm.form.username,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form, "username", $$v)
                                  },
                                  expression: "form.username",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-layout",
                        [
                          _c(
                            "v-flex",
                            { attrs: { xs12: "" } },
                            [
                              _c("v-text-field", {
                                directives: [
                                  {
                                    name: "validate",
                                    rawName: "v-validate",
                                    value: "required|min:6|max:50",
                                    expression: "'required|min:6|max:50'",
                                  },
                                ],
                                attrs: {
                                  "prepend-icon": "fal fa-key",
                                  color: "accent",
                                  autocomplete: "current-password",
                                  "data-vv-as": "password",
                                  "data-vv-name": "password",
                                  "error-messages":
                                    _vm.errors.collect("password"),
                                  label: "Password",
                                  name: "password",
                                  type: "password",
                                  "aria-required": "true",
                                },
                                model: {
                                  value: _vm.form.password,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form, "password", $$v)
                                  },
                                  expression: "form.password",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-card-actions",
                        [
                          _c(
                            "v-btn",
                            {
                              staticClass: "login-forgot-password-link",
                              attrs: {
                                "aria-label": "Forgot password",
                                small: "",
                                color: "transparent",
                                to: _vm.toForgotPassLink,
                              },
                            },
                            [
                              _vm._v(
                                "\n              " +
                                  _vm._s(
                                    _vm.$t("components.login.buttons.resetPass")
                                  ) +
                                  "\n            "
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c("v-spacer"),
                          _vm._v(" "),
                          _c(
                            "v-btn",
                            {
                              attrs: {
                                "aria-label": "Sign in",
                                color: "accent",
                                type: "submit",
                              },
                            },
                            [
                              _vm._v(
                                "\n              " +
                                  _vm._s(
                                    _vm.$t(
                                      "components.resetPass.buttons.signin"
                                    )
                                  ) +
                                  "\n            "
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                2
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }